module.exports = __webpack_public_path__ + "static/media/people.9bd1d70d.svg";